<template>
  <div class="discussion">
    <div class="header">
      <span>{{ $lang.messages.expenseDiscussion }}</span>
      <hr class="horizontal-line">
    </div>

    <div class="section">
      <div
        class="opened-discussion-panel"
      >
        <form
          name="newCommentForm"
          novalidate
          @submit.prevent="onNewCommentFormSubmitted"
          autocomplete="off"
        >
          <div class="new-comment-wrapper">
            <textarea
                type="text"
                :placeholder="$lang.messages.typeYourComment"
                class="new-comment-input"
                v-model="MX_newMsg"
                @paste="postNlpOnPaste"
                ref="newComment"
                id="new-comment"
                rows="1"
                @keydown="handleKeydown"
                @keydown.space="checkNLP"
                maxlength="500"
            >
            </textarea>
            
            <span
              class="spirit-ico"
              :class="{'arrow' : spiritTooltip }"
              @mouseover="showSpiritTooltip"
              @click="showSpiritTooltip">
              
              <img
                v-show="nlp === 'positive'"
                src="@/assets/images/smiley_positive_ico.png"
                alt="emotico"
              >
              <img
                v-show="nlp === 'neutral'"
                src="@/assets/images/smiley_neutral_ico.png"
                alt="emotico"
              >
              <img
                v-show="nlp === 'mixed'"
                src="@/assets/images/smiley_mixed_ico.png"
                alt="emotico"
              >
              <img
                v-show="nlp === 'negative'"
                src="@/assets/images/smiley_negative_ico.png"
                alt="emotico"
              >
            </span>
            
            <f-p-tooltip
              v-show="spiritTooltip"
              v-click-outside="hideSpiritTooltip"
              :hideTooltipInside="hideSpiritTooltip"
              :tooltipTitle="$lang.messages.tp_spiritTitle"
              :tooltipContent="$lang.messages.tp_spiritText"
              :tooltipHasLink="''">
            </f-p-tooltip>
            
            <button type="submit" class="new-comment-btn" :disabled="loading">
              <img src='@/assets/images/payments/send_ico.png' />
              <span>{{ $lang.messages.addComment }}</span>
            </button>

            <span class="textarea-counter" :class="{'textarea-counter--blink': MX_newMsg.length >= 500}">
              {{MX_newMsg.length >= 500 ? 500 : MX_newMsg.length}} / 500
            </span>
          </div>

          <!-- Confirm Modal -->
          <n-l-p-confirm-modal
            ref="confirmModalComponent"
            @confirmMessage="confirmMessage">
          </n-l-p-confirm-modal>
        </form>

        <div>
          <div class="comments-notifications-wrapper">
            <hr class="horizontal-line">
            <span class="comments-total">
              {{ commentCount }} {{ $lang.messages.comments }}
            </span>
          </div>

          <div class="comments-wrapper" @scroll="scrollComments">
            <div class="comments-container">
              <div
                v-for="(comment, indexComments) in comments"
                :key="indexComments"
              >
                <div
                  v-if="comment.author !== coparentName"
                  class="comment coparent-comment"
                >
                  <span class="sender">{{ comment.author }}</span>
                  <span class="date">{{ formatTime(comment.created) }}</span>
                  <div class="message">
                    <p>{{ comment.content }}</p>
                  </div>
                </div>

                <div
                  v-if="comment.author === coparentName"
                  class="comment"
                >
                  <span class="sender">{{ comment.author }}</span>
                  <span class="date">{{ formatTime(comment.created) }}</span>
                  <div class="message">
                    <p>{{ comment.content }}</p>
                  </div>
                </div>

              </div>
              <!-- Unread comment design -->
              <!-- <div class="comment unread-comment">
                <span class="sender">Janny Black</span>
                <span class="date">23rd Jul 2019; 02:20 PM</span>
                <div class="message">
                  Curabitur in dui non velit maximus gravida at id ex.
                  Aenean dapibus, dolor porttitor ultricies pulvinar,
                  ligula dui vehicula elit, ut molestie erat felis et nulla.
                  Pellentesque lobortis ac libero ut tempus.
                  Ut viverra leo sit amet dictum pretium.
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { GET_ALL_COMMENTS, ADD_COMMENT, POST_NLP_SCORE } from "@/store/action.types"
import NLPConfirmModal from "@/components/common/modals/NLPConfirmModal";
import { format } from 'date-fns';
import { checkSentiment } from "@/mixins/checkSentiment";
import { checkSentimentOnPaste } from "@/mixins/checkSentimentOnPaste";
import vClickOutside from 'v-click-outside';
import STATUS_CODES from "@/common/statusCodes";

export default {
  name: "discussion",
  components: {
    NLPConfirmModal,
    'f-p-tooltip': () => import('@/components/common/FPTooltip'),
  },
  mixins: [
    checkSentiment,
    checkSentimentOnPaste
  ],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    guid: {
      type: String,
      required: true,
      default: () => ''
    },
    commentCountProp: {
      type: Number,
      required: true,
      default: () => 0
    },
    discuss: {
      type: Boolean,
      required: true,
      default: () => false
    }
  },
  data() {
    return {
      commentCount: 0,
      page: 0,
      size: 10,
      comments: [],
      text: undefined,
      nlp: 'positive',
      space: 0,
      confirm: true,
      scrollerPositionDown: false,
      initialContainerHeight: 0,
      loading: false,
      spiritTooltip: false
    };
  },
  computed: {
    ...mapGetters({
        coparentGuid: 'coparentGuid',
        coparents: 'coparents'
    }),
    coparentName() {
        let name = '';
        for (let i of this.coparents) {
            if (i.guid === this.coparentGuid) {
                name = i.name;
                break;
            }
        }

        return name;
    }
  },
  mounted() {
    if (this.discuss) {
      this.$refs.newComment.focus()
    }
    this.getAllComments(this.guid, this.page, this.size)
    this.commentCount = this.clone(this.commentCountProp)
  },
  methods: {
    ...mapActions({
      getAllCommentsAction: GET_ALL_COMMENTS,
      addCommentAction: ADD_COMMENT,
      postNlpScore: POST_NLP_SCORE
    }),
    checkNLP() {
      this.MX_checkNlpOnDiscussion()
    },
    postNLP() {
      this.MX_postNLP()
    },
    postNlpOnPaste (e) {
      this.text = e.clipboardData.getData('text');

      this.MX_postNlpOnPaste(this.text, e)
    },
    confirmModalOpen() {
      this.$refs.confirmModalComponent.show(this.newMessage);
    },
    confirmMessage() {
      this.confirm = true;
      this.nlp = 'neutral';
      this.onNewCommentFormSubmitted();
    },
    handleKeydown(e) {
      if (e.key === 'Enter' && e.ctrlKey) {
        this.MX_newMsg = this.MX_newMsg + "\n"
      } else if (e.key === 'Enter' && !e.ctrlKey) {
        this.onNewCommentFormSubmitted()
      }
    },
    onNewCommentFormSubmitted() {
      if (!this.loading) {
        if (this.nlp === 'negative') {
          this.confirm = false;
          this.confirmModalOpen();
        }
        if (this.confirm && this.MX_newMsg.replace(/\s/g, '').length) {
          this.loading = true;
          this.addCommentAction({
            expenseGuid: this.guid,
            content: this.MX_newMsg
          })
          .then(() => {
            this.loading = false;
            this.getAllComments(this.guid, this.page, this.size);
            this.MX_newMsg = '';
            this.nlp = 'positive';
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(error.response.data.status.desc, 'ERROR')
            }
          });
          this.commentCount = this.commentCount + 1
        }
      }
    },
    getAllComments(guid, page, size) {
      let data = {
        guid: guid,
        page: page,
        size: size
      }
      this.getAllCommentsAction(data)
      .then(response => {
        this.comments = response.data.data.content
      })
      .catch(error => {
        if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
          this.$snotify.error('Something went wrong.', 'ERROR');
        }
      });
    },
    getCommentsOnScroll(guid, page, size) {
      let data = {
        guid: guid,
        page: page,
        size: size
      };
      this.getAllCommentsAction(data)
        .then(response => {
          response.data.data.content.forEach(element => {
            this.comments.push(element)
          });
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error('Something went wrong.', 'ERROR');
          }
        });
    },
    scrollComments(event) {
      let wrapper = document.querySelector('.comments-wrapper')
      let container = document.querySelector('.comments-container')

      if (wrapper && container) {
        if (wrapper.getBoundingClientRect().bottom + 10 >= container.getBoundingClientRect().bottom) {
          this.scrollerPositionDown = true
        } else {
          this.scrollerPositionDown = false
        }
      }

      if ((event.target.scrollTop + event.target.offsetHeight) >= event.target.scrollHeight) {
        let neededPage = 0
        if (this.scrollerPositionDown) {
          neededPage = this.page + 1
        }
        this.page = neededPage

        this.getCommentsOnScroll(this.guid, this.page, this.size)
      }
    },
    formatTime(time) {
      return format(new Date(time), 'MMM d, yyyy; hh:mm a')
    },
    clone(obj) {
      var copy;

      if (null == obj || "object" != typeof obj) return obj;

      if (obj instanceof Date) {
          copy = new Date();
          copy.setTime(obj.getTime());
          return copy;
      }

      if (obj instanceof Array) {
          copy = [];
          for (var i = 0, len = obj.length; i < len; i++) {
              copy[i] = clone(obj[i]);
          }
          return copy;
      }

      if (obj instanceof Object) {
          copy = {};
          for (var attr in obj) {
              if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
          }
          return copy;
      }
    },
    showSpiritTooltip(e) {
      e.stopPropagation();
      this.spiritTooltip = true
    },
    hideSpiritTooltip() {
      this.spiritTooltip = false;
    },
  }
};
</script>
